import * as React from "react";
import MDEditor from "@uiw/react-md-editor";
import MarkupErrorBoundary from "../error-boundary/MarkupErrorBoundary";


export const botTextToComponentWithLinks = (text: string) => {
    if (!text) { return };
    if (isAllCharactersSame(text)) { return text };
    return <MarkupErrorBoundary text={text}>
                <MDEditor.Markdown source={text} linkTarget="_blank" />
            </MarkupErrorBoundary>;
}

export const clientMessageTextToComponentWithLinks = (text: string) => {
    if (!text) { return };
    const lines = text.split(/\n/);

    const allLine = lines.map((line, j) => {
        const tokens = line.split(/\s/);
        const contents = tokens.map((token, i) => {
            const hasSpace = i !== (tokens.length - 1);
            const maybeSpace = hasSpace ? ' ' : '';

            if (token.match(/(\b(https?|ftp|file|viber):\/\/[\p{L}0-9\-+&@#\/%?=~_|!:,.;]*[\p{L}0-9+&@#\/%=~_|])/iug)) {
                const url = token.match(/(\b(https?|ftp|file|viber):\/\/[\p{L}0-9\-+&@#\/%?=~_|!:,.;]*[\p{L}0-9+&@#\/%=~_|])/iug);
                return (
                    <>
                        {url ? token.split(url[0])[0] : ""}
                        <a
                            key={i}
                            href={url ? url[0] : ""}
                            target="_blank">
                            {url ? url[0] : ""}
                        </a>
                        {url ? token.split(url[0])[1] : ""}
                        {maybeSpace}
                    </>
                );
            } else {
                return token + maybeSpace;
            }
        })
        return (
            line === '' ? <br></br> : <div key={j} style={{ textAlign: "left" }}>{contents}</div>
        )
    })

    return <div>{allLine}</div>;
}


const isAllCharactersSame = (str: string) => {
    for (let i = 1; i < str.length; i++) {
        if (str[i] !== str[0]) return false;
    }
    return true;
}